/* SS - FAQ #9 accordion: several items may be open at once, nothing open by default.
   Open: answer shown, then padding-top + measured height applied (0.2s CSS transition), arrow rotates to 180deg (0.3s).
   Close: padding/height to 0, arrow back to 0deg, display:none after 300ms.
   Window resize (250ms debounce) re-measures the most recently opened answer. */
if (!customElements.get('ss-faq-9')) {
  customElements.define('ss-faq-9', class extends HTMLElement {
    connectedCallback() {
      if (this.onResize) { window.addEventListener('resize', this.onResize); return; }
      const pt = +this.dataset.pt || 0;
      const toggles = [...this.querySelectorAll('.ssf9-t')];
      const answers = this.querySelectorAll('.ssf9-a');
      const icons = this.querySelectorAll('.ssf9-ar');
      const height = (i) => answers[i].firstElementChild.offsetHeight + pt;
      let active = -1;
      let timer;
      const open = (i) => {
        const a = answers[i];
        a.style.display = 'block';
        const h = height(i);
        setTimeout(() => {
          a.style.paddingTop = pt + 'px';
          a.style.paddingBottom = '0px';
          a.style.height = h + 'px';
          icons[i].style.setProperty('--rotate', '180deg');
        });
      };
      const close = (i) => {
        const a = answers[i];
        a.style.paddingTop = 0;
        a.style.paddingBottom = 0;
        a.style.height = 0;
        icons[i].style.setProperty('--rotate', '0deg');
        setTimeout(() => { a.style.display = 'none'; }, 300);
      };
      toggles.forEach((t, i) => t.addEventListener('click', () => {
        if (answers[i].style.display === 'none') { open(i); active = i; } else { close(i); active = -1; }
      }));
      this.onResize = () => {
        clearTimeout(timer);
        timer = setTimeout(() => { if (active !== -1) answers[active].style.height = height(active) + 'px'; }, 250);
      };
      window.addEventListener('resize', this.onResize);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }
  });
}
